import FeatureGates from '@atlaskit/feature-gate-js-client';

const getExperimentValue = FeatureGates.getExperimentValue;

const EXPERIMENT = 'platform_global_preview_panels_default_width';
export const IS_ENABLED = 'isEnabled';
export const MINIMUM_WIDTH = 'minimumWidth';
export const RATIO = 'ratio';

const PANEL_DEFAULT_WIDTH = 400;
const PANEL_MAX_WIDTH = 1000;
const FALLBACK_RATIO = 0.25;

export const getDefaultPanelWidth = () => {
	if (!getExperimentValue(EXPERIMENT, IS_ENABLED, false)) {
		return PANEL_DEFAULT_WIDTH;
	}

	const windowWidth = window.innerWidth;

	const minWidthForWiderPanel: number = getExperimentValue(
		EXPERIMENT,
		MINIMUM_WIDTH,
		Number.MAX_VALUE,
	);

	let width = PANEL_DEFAULT_WIDTH;
	if (windowWidth > minWidthForWiderPanel) {
		const panelWidthToWindowWidthRatio: number = getExperimentValue(
			EXPERIMENT,
			RATIO,
			FALLBACK_RATIO,
		);
		const proposedPanelWidth = Math.round(windowWidth * panelWidthToWindowWidthRatio);

		width = proposedPanelWidth < PANEL_MAX_WIDTH ? proposedPanelWidth : PANEL_MAX_WIDTH;
	}
	return width;
};
